import { AWebsocketState } from "./AWebsocketState";
import { ConnectingState } from "./ConnectingState";
import { IdleState } from "./IdleState";

export class DisconnectedState extends AWebsocketState {
  private retryTimerId: number | null = null;

  override enter(): void {
    if (!this.client.shouldConnect()) {
      console.log("DisconnectedState: auth invalid, staying disconnected");
      this.client.setState(new IdleState(this.client));
      return;
    }

    const attempt = this.client.incrementReconnectAttempt();
    const cfg = this.client.getReconnectConfig();

    if (cfg.maxAttempts !== Number.POSITIVE_INFINITY && attempt > cfg.maxAttempts) {
      console.log("DisconnectedState: max reconnect attempts reached, staying disconnected");
      return;
    }

    const delay = this.client.getBackoff()(attempt);
    console.log(`DisconnectedState: scheduling reconnect attempt #${attempt} in ${delay}ms`);

    this.retryTimerId = this.client.getClock().setTimeout(() => this.tryReconnect(), delay);
  }

  override exit(): void {
    if (this.retryTimerId !== null) {
      this.client.getClock().clearTimeout(this.retryTimerId);
      this.retryTimerId = null;
    }
  }

  override connect(): void {
    if (this.retryTimerId !== null) {
      this.client.getClock().clearTimeout(this.retryTimerId);
      this.retryTimerId = null;
    }
    this.tryReconnect();
  }

  override disconnect(): void {
    if (this.retryTimerId !== null) {
      this.client.getClock().clearTimeout(this.retryTimerId);
      this.retryTimerId = null;
    }
    console.log("DisconnectedState: staying disconnected (no auto-reconnect)");
  }

  private tryReconnect(): void {
    console.log("DisconnectedState: reconnecting now...");
    this.client.openFreshSocket();
    this.client.setState(new ConnectingState(this.client));
  }
}
